/* Oppportunities View */
import * as React from "react";
import { action, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { hashHistory } from "react-router";
import { sort } from "../../utils/data";
import { ILocalization } from "../../models/localization";
import SeekerStore from "../../stores/seekerStore";
import OpportunityStore from "../../stores/opportunityStore";
import { OpportunitySummary, CategoryOps } from "../../models/opportunity";
import { Row, Col, Grid } from "react-flexbox-grid";
import Busy from "../../components/widgets/busy";
import BackButton from "../../components/widgets/backBtn";
import OpportunitySummaryCard from "../../components/opportunity/opSummary";
import * as s from "./opportunities.css";

interface IParams {
  catId: string;
}
@inject("store") @observer
export default class OpportunitiesVw extends React.Component<{ store: SeekerStore, params: IParams }, {}> {
  private _opStore: OpportunityStore;
  
  constructor(props: any) {
    super(props);
    this._opStore = this.props.store.opportunityStore;
  }
  componentWillMount(): void {
    this._opStore.initCategoryOps(this.props.params.catId);
    window.scrollTo(0, 0);
  }
  componentDidMount(): void {
    this.props.store.getHelpTopics();
  }

  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    const ops: CategoryOps = this._opStore.categoryOps[this.props.params.catId];
    const renderedIds: Array<string> = new Array<string>();
    let opItems: JSX.Element[] = [];
    let catName: string = "";
    if (ops && ops.opportunities) {
      sort(ops.opportunities, "name").map((os: OpportunitySummary, i: number): void => {
        if (renderedIds.indexOf(os.idHash) === -1) {
          renderedIds.push(os.idHash);
          opItems.push(<OpportunitySummaryCard key={i} store={this.props.store} op={os} />);
          if (!catName) {
            catName = os.category;
          }
        }
      });
    }
    return (
      <div>
        <Busy show={opItems.length === 0} size="sm" msg={local.loadingOps} />      
        <Grid>
          <BackButton />     
          <Row middle="xs"><h3 className={s.header}>{catName}</h3></Row>
          <Row>{opItems}</Row>
        </Grid>
      </div> );}
}


// WEBPACK FOOTER //
// ./src/views/opportunities/index.tsx